/** @jsxRuntime classic */
/** @jsx jsx */
//@ts-nocheck
import { jsx, css } from '@emotion/react';
import camelcase from 'lodash.camelcase';
import { FunctionComponent } from 'react';
import colors from '../css/colors';
import ButtonSpinner from './ButtonSpinner';
import styled from '@emotion/styled';

const fieldStyles = {
  backgroundColor: '#fff',
  border: `1px solid ${colors.grey300}`,
  borderRadius: 5,
  caretColor: colors.grey500,
  cursor: 'pointer',
  display: 'block',
  height: 48,
  '&:hover': { border: `1px solid ${colors.grey}` },
  '::placeholder': {
    color: colors.grey500,
  },
  ' :focus': {
    border: `1px solid ${colors.grey100}`,
    outline: `none`
  },
};

const disabledStyles = {
  backgroundColor: colors.grey600,
  cursor: 'not-allowed',
  // border: `1px solid ${colors.hudsonRed}`,
};

const noop = () => { };

interface IProps {
  label?: string;
  name?: string;
  placeholder?: string;
  value?: string;
  styles?: {};
  width?: string;
  error?: boolean;
  disabled?: boolean;
  type?: string;
  onChange?: (value: any) => void;
  onBlur?: (e?:any) => {};
  onKeyUp?: () => {};
  onKeyDown?: () => {};
  loadingStatus?: boolean;
}

const TextField: FunctionComponent<IProps> = props => {
  const {
    label,
    name,
    placeholder,
    value,
    styles = {},
    width,
    error = false,
    disabled = false,
    type = 'text',
    onChange = e => { },
    onBlur = noop,
    onKeyUp = noop,
    onKeyDown = noop,
    loadingStatus = false,
  } = props
  const getWidth = (width: any) => {
    if (!width) {
      return undefined
    }

    return width.toString().includes('%') || width.toString().includes('px') ? width : parseInt(width)
  }

  return (
    <div
      css={[{ display: 'inline-block', verticalAlign: 'top', width: getWidth(width) }, styles]}
    >
      {error ||
        (label && (
          <div
            style={{
              marginBottom: 8,
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            {label && <span style={{ display: 'inline-block' }}>{label}</span>}
            {error && <span style={{ color: colors.hudsonRed }}>Error</span>}
          </div>
        ))}
      <input
        type={type}
        name={camelcase(name || label)}
        css={[fieldStyles, disabled && disabledStyles, { width: getWidth(width) }]}
        placeholder={placeholder}
        onChange={onChange}
        value={value}
        disabled={disabled}
        onBlur={onBlur}
        onKeyUp={onKeyUp}
        onKeyDown={onKeyDown}
        autoComplete="off"
      />
    </div>
  );
}

export default TextField;